import React from 'react';
import { NavigationBar } from 'components/navigation/NavigationBar';
import LegalNotices from 'components/banner/LegalNotices';

export class Layout extends React.Component
{
	public render() {
		return <>
			<div className='page-container'>
				<NavigationBar />
				<div className='page-content'>
					{this.props.children}
					<LegalNotices />
				</div>
			</div>
		</>
	}
}

export default Layout;